module.exports = __webpack_public_path__ + "static/media/img3-3.9ed31293.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/nutricheck_foliar/ZN/img3-3.png
// module id = 1615
// module chunks = 3